<template>
    <payment-result-card
        :variant="cardVariant"
        :title="cardTitle"
        :description="cardDescription"
    >
        <template v-if="hasActions" #actions>
            <app-button
                v-if="canResumePayment"
                color="brand-blue"
                @click="resumePayment"
            >
                {{ resumeLabel }}
            </app-button>
            <app-button
                :border="state !== 'paid'"
                color="brand-blue"
                @click="goToPlan"
            >
                {{ state === "paid" ? "Ir a Mi plan" : "Volver a Mi plan" }}
            </app-button>
        </template>
    </payment-result-card>
</template>

<script>
import platformPaymentResult from "@/mixins/platformPaymentResult";

import PaymentResultCard from "@/components/utils/PaymentResultCard.vue";

export default {
    name: "PlanPaymentResultPage",

    components: { PaymentResultCard },

    mixins: [platformPaymentResult],

    data: () => ({
        resultSource: "my_plan"
    }),

    methods: {
        handlePaid() {
            this.state = "paid";
        },

        goToPlan() {
            this.$router.replace("/app/plan");
        }
    }
};
</script>
